<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="仓库管理"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="仓库名称" prop="WhName">
              <el-input
                v-model="data.WhName"
                placeholder="请填写仓库名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col
            :span="$store.state.isMB ? 24 : 12"
            v-if="loginInfo.UserType == 0"
          >
            <el-form-item
              label="所属商家"
              prop="StoreId"
              :rules="loginInfo.UserType == 0 ? typeRules.StoreId : null"
            >
              <el-select
                v-model="data.StoreId"
                @change="onChange"
                placeholder="请选择商家"
              >
                <el-option
                  v-for="item in busiList"
                  :key="item.RecordId"
                  :label="item.BusiName"
                  :value="item.RecordId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="isMB?24:12" v-if="loginInfo.UserType == 0">

               <el-form-item label="仓库类型" prop="WhType">
                 <el-select v-model="data.WhType" placeholder="请选择仓库类型" clearable>
                    <el-option label="保税仓" :value="0" ></el-option>
                    <el-option label="一般仓" :value="1"></el-option>
                  </el-select>
               </el-form-item>

           </el-col>
           <el-col :span="isMB?24:12" v-else-if="loginInfo.UserType == 1">

               <el-form-item label="仓库类型" prop="WhType">
                 <el-select v-model="data.WhType" placeholder="请选择仓库类型" clearable>
                 
                    <el-option label="一般仓" :value="1"></el-option>
                  </el-select>
               </el-form-item>

           </el-col> -->
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系人" prop="ContactName">
              <el-input
                v-model="data.ContactName"
                placeholder="请填写联系人"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系电话" prop="ContactPhone">
              <el-input
                v-model="data.ContactPhone"
                placeholder="请填写联系电话"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="仓库地址" prop="WhAddress">
              <el-input
                v-model="data.WhAddress"
                placeholder="请填写仓库地址"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        WhName: "",
        WhAddress: "",
        ContactName: "",
        ContactPhone: "",
        WhCode: "",
        OrderId: 0,
        State: 1,
        WhType: 1,
        StoreId: null,
      },
      api: require("@/api/wh/base").default,
      api2: require("@/api/shop/business").default,
      isMB: this.$store.state.isMB,
      rules: {
        WhName: [{ required: true, message: "仓库名称不能为空" }],
        WhType: [{ required: true, message: "仓库类型不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
        ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
      },
      typeRules: {
        StoreId: [{ required: true, message: "请选择所属商家" }],
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      busiList: [],
    };
  },
  methods: {
    init() {
      this.api2.list({ Status: 1, CheckState: 2 }).then((res) => {
        // console.log(res.Data);
        this.busiList = res.Data;
      });
    },
    onCreateOpened(row) {
      this.init();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.init();
    },
    onBeforeSave() {},
    onClosed() {},
    onChange(val) {
      if (this.data.RecordId == 0) {
        this.api.getMaxOrderId(val).then((res) => {
          if (res.Code == 0) this.data.OrderId = res.Data;
        });
      }

      console.log(val, "aa");
    },
  },
};
</script>